import { Controller } from 'stimulus';
import Swiper, { Navigation } from 'swiper'
import throttle from 'lodash/throttle'

Swiper.use([Navigation])

export default class extends Controller {
  static targets = ['slider', 'nextButton', 'prevButton', 'currentCount', 'totalCount', 'pager']

  get totalSlides() {
    return document.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length
  }

  connect() {
    const eventCard = this.element.querySelectorAll('.event-card');
    const lastEventCard = eventCard[eventCard.length - 1];
    if (lastEventCard) {
      lastEventCard.addEventListener(
        'eventCardProcessed',
        this.handleLastEventCardProcessed.bind(this)
      );
    }
  }

  handleLastEventCardProcessed() {
    this.hideRepeatDailyEvents();
    this.preInitSlider = this.sliderTarget.cloneNode(true);
    // Handle the window resize event
    // this will destroy the slider if it exists,
    // and then re-initialize it based on the window width
    this.throttleResize = throttle(this.resize.bind(this), 250, { leading: false });
    window.addEventListener('resize', this.throttleResize);
    this.initSlider();
  }

  hideRepeatDailyEvents() {
    let dailyEvents = document.querySelectorAll('[data-daily="true"]');
    let dailyArray = {};
    dailyEvents.forEach((event) => {
      dailyArray[event.dataset.eventId] = (dailyArray[event.dataset.eventId] || 0) + 1;
      if (dailyArray[event.dataset.eventId] > 1) {
        event.remove();
      }
    });
  }

  disconnect() {
    // if the slider exists, destroy it
    if (this.swiper) this.swiper.destroy(true, true);
  }

  /**
   * Handle the window resize event -
   * This will destroy the slider if it exists, and then re-initialize it.
   * @returns {void}
   */
  resize() {
    this.disconnect()
    if (!this.hasSliderTarget) return
    // replace and re-initialize the slider
    this.sliderTarget.replaceWith(this.preInitSlider.cloneNode(true))
    this.initSlider()
  }

  /**
   * Initialize the slider -
   */
  initSlider() {
    let loop = true;
    if (document.querySelectorAll('.swiper-slide').length < 2) {
      loop = false;
    }

    const $this = this
    this.swiper = new Swiper(this.sliderTarget, {
      slidesPerView: 1.4,
      speed: 400,
      threshold: 40,
      centeredSlides: true,
      spaceBetween: 10,
      loop: loop,
      resizeObserver: false,
      navigation: {
        nextEl: this.nextButtonTarget,
        prevEl: this.prevButtonTarget,
      },
      breakpoints: {
        768: {
          threshold: 70,
          slidesPerView: 3,
          slidesPerGroup: 3,
          centeredSlides: false,
          spaceBetween: 15,
          loop: false,
        },
        1024: {
          threshold: 120,
          slidesPerView: 4,
          slidesPerGroup: 4,
          centeredSlides: false,
          spaceBetween: 15,
          loop: false,
        },
      },
      on: {
        init() {
          $this.setPager(this);
        },
        slideChange() {
          $this.setPager(this);
        },
      }
    })
  }

  setPager(swiper) {
    let totalCount = this.pages(swiper);
    let currentCount = this.currentPage(swiper);
    this.currentCountTarget.textContent = currentCount;
    this.totalCountTarget.textContent = totalCount;
    if (totalCount === 1) {
      this.pagerTarget.style.display = 'none';
    } else {
      this.pagerTarget.style.display = 'flex';
    }
  }

  slidesPerGroup(swiper) {
    return swiper.params.slidesPerGroup
  }

  pages(swiper) {
    return Math.ceil(this.totalSlides / this.slidesPerGroup(swiper))
  }

  currentPage(swiper) {
    return Math.ceil(swiper.realIndex / this.slidesPerGroup(swiper)) + 1
  }
}
